type Options = Intl.NumberFormatOptions

export default function useNumberFormat(options?: Options) {
  const i18n = useI18n()

  function formatNumber(value: number, maximumFractionDigits?: number) {
    return new Intl.NumberFormat(i18n.locale, {
      style: 'decimal',
      minimumFractionDigits: 0,
      ...options,
      maximumFractionDigits,
    }).format(value)
  }

  return { formatNumber }
}
